import type { FC } from "react";
import OutlinedButton from "../../atoms/buttons/OutlinedButton";
import { theme } from "../../../theme";
import { CrossIcon } from "../../atoms/icons/CrossIcon";
import { useRejectInvoicesFlow } from "./useRejectInvoicesFlow";

type Props =
  | {
      type: "single";
      invoiceId: string;
      invoiceIds?: never;
      buttonLabel: string;
      fileId?: string;
      size?: "small" | "medium";
    }
  | {
      type: "multiple";
      invoiceIds: string[];
      invoiceId?: never;
      buttonLabel: string;
      fileId?: never;
      size?: "small" | "medium";
    };

const RejectInvoicesButton: FC<Props> = (props) => {
  const { openModal, modal } = useRejectInvoicesFlow(
    props.type === "single"
      ? { type: "single", invoiceId: props.invoiceId, fileId: props.fileId }
      : { type: "multiple", invoiceIds: props.invoiceIds },
  );

  return (
    <div>
      <OutlinedButton
        title={props.buttonLabel}
        icon={<CrossIcon />}
        color={theme.colors.text}
        medium={props.size === "medium"}
        onClick={openModal}
      />
      {modal}
    </div>
  );
};

export default RejectInvoicesButton;
